export enum QuoteAssetClassDto {
  Equity = 'Equity',
  Option = 'Option',
  MutualFund = 'MutualFund',
  MoneyMarket = 'MoneyMarket',
  Bond = 'Bond',
  Index = 'Index',
}

export interface QuoteDto {
  AskPrice: number;
  AskSize: number;
  AssetClass: QuoteAssetClassDto;
  BidAskMidPrice?: number;
  BidPrice: number;
  BidSize: number;
  CloseDate?: string;
  ClosePrice: number;
  Description?: string;
  Exchange?: string;
  High: number;
  LastTradePrice: number;
  LastTradeVolume: number;
  Low: number;
  Multiplier: number;
  NetChange: number;
  Open: number;
  OpenInterest: number;
  QuoteTime: string;
  ReceivedTime?: string;
  SecurityId: number;
  Symbol?: string;
  TradeTime?: string;
  UnderlyingPrice: number;
  UnderlyingSymbol?: string;
  Volume?: number;
}

export interface QuoteChartDto {
  C: number;
  D: string;
  H: number;
  L: number;
  O: number;
  S?: string;
  V: number;
}

export interface GetQuoteListQueryParamsDto {
  symbols: string;
}

export interface GetQuoteListDto {
  queryParams: GetQuoteListQueryParamsDto;
}

export interface GetQuoteListResponseDto {
  data: QuoteDto[];
}

export interface GetQuoteParamsDto {
  symbol: string;
}

export interface GetQuoteDto {
  params: GetQuoteParamsDto;
}

export interface GetQuoteChartParamsDto {
  symbol: string;
}

export enum QuoteChartQueryParamIntervalDto {
  OneDay = '1d',
  OneWeek = '1w',
  OneMonth = '1m',
  SixMonths = '6m',
  OneYear = '1y',
}

export interface GetQuoteChartQueryParamsDto {
  interval: QuoteChartQueryParamIntervalDto;
}

export interface GetQuoteChartDto {
  params: GetQuoteChartParamsDto;
  queryParams: GetQuoteChartQueryParamsDto;
}

export interface GetQuoteChartResponseDto {
  data: QuoteChartDto[];
}
